export default "__VITE_ASSET__2b824908__"